module.exports = __webpack_public_path__ + "img/aplicacoes_empilhadeiras.a789bc59.jpg";